import { render, staticRenderFns } from "./AdminTransformRecipe.vue?vue&type=template&id=45bd6d92&scoped=true&"
import script from "./AdminTransformRecipe.vue?vue&type=script&lang=js&"
export * from "./AdminTransformRecipe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45bd6d92",
  null
  
)

export default component.exports